// extracted by mini-css-extract-plugin
export default {"upload":"style_upload__t422Q__oBlIk","upload-list":"style_upload-list__Q9HDc__oBlIk","upload-input":"style_upload-input__vXk4w__oBlIk","tips":"style_tips__3Gpnu__oBlIk"};